import React from "react";
import { Box, Typography, CardContent, useTheme } from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { StyledCard } from "../../common/StyledCard";
import { formatCurrency } from "../../../utils/currencyUtils";
import { CreditNoteReasonBiDto } from "../../../shared/dtos/bi/CreditNoteReasonBiDto";

interface CreditNoteReasonsWidgetProps {
  data?: CreditNoteReasonBiDto[];
}

const CreditNoteReasonsWidget: React.FC<CreditNoteReasonsWidgetProps> = ({
  data = [],
}) => {
  const theme = useTheme();
  const VIBRANT_COLORS = [
    "#ff4081",
    "#ff9800",
    "#b388ff",
    "#00e676",
    "#00b0ff",
  ];

  return (
    <StyledCard
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <CardContent
        sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 3 }}>
          Credit Note Reasons
        </Typography>

        {data.length > 0 ? (
          <Box sx={{ flexGrow: 1, width: "100%", minHeight: 300 }}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={70}
                  outerRadius={100}
                  paddingAngle={3}
                  dataKey="totalRefunded"
                  nameKey="reason"
                >
                  {data.map((_, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={VIBRANT_COLORS[index % VIBRANT_COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip
                  contentStyle={{
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: 8,
                    borderColor: theme.palette.neutral.dark,
                    color: theme.palette.neutral.light,
                  }}
                  formatter={(value, name, props) => [
                    `${formatCurrency(Number(value))} (${props.payload.count} items)`,
                    name,
                  ]}
                />
                <Legend
                  verticalAlign="bottom"
                  height={36}
                  iconType="circle"
                  wrapperStyle={{ color: theme.palette.neutral.light }}
                />
              </PieChart>
            </ResponsiveContainer>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              minHeight: 300,
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              No credit notes found.
            </Typography>
          </Box>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default CreditNoteReasonsWidget;
